import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useI18n } from "../../contexts/I18nContext";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { CalendarOff } from "lucide-react";
import { toast } from "sonner";
import { localName, localFullName } from "../../lib/localName";

export default function LeavesPage() {
  const {  t , lang } = useI18n();
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [filter, setFilter] = useState("pending");

  const load = () => {
    const url = filter === "all" ? "/leave-requests" : `/leave-requests?status=${filter}`;
    api.get(url).then(r => setItems(r.data || []));
  };
  useEffect(() => { load(); api.get("/employees").then(r => setEmps(r.data || [])); }, [filter]);

  const decide = async (id, status) => {
    try { await api.put(`/leave-requests/${id}/decide`, { status }); toast.success(t("success")); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Error"); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h1 className="text-3xl font-semibold flex items-center gap-3"><CalendarOff className="w-7 h-7 text-primary" /> {t("leaves")}</h1>
        <Select value={filter} onValueChange={setFilter}>
          <SelectTrigger className="w-48" data-testid="leaves-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("all") || "All"}</SelectItem>
            <SelectItem value="pending">{t("pending")}</SelectItem>
            <SelectItem value="approved">{t("approved")}</SelectItem>
            <SelectItem value="rejected">{t("rejected")}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <Card className="border shadow-none">
        <ul className="divide-y divide-border">
          {items.map(l => {
            const emp = emps.find(e => e.id === l.employee_id);
            return (
              <li key={l.id} className="p-4 flex items-center justify-between gap-3 hover:bg-muted/30" data-testid={`leave-row-${l.id}`}>
                <div className="flex-1 min-w-0">
                  <div className="font-medium">{localFullName(emp, lang) || l.employee_id} · <span className="text-xs text-muted-foreground">{t(l.leave_type)}</span></div>
                  <div className="text-xs text-muted-foreground">{l.start_date} → {l.end_date} {l.reason ? `· ${l.reason}` : ""}</div>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${l.status === "approved" ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30" : l.status === "rejected" ? "bg-destructive/10 text-destructive" : "bg-amber-100 text-amber-700 dark:bg-amber-900/30"}`}>{t(l.status)}</span>
                {l.status === "pending" && (
                  <div className="flex gap-1">
                    <Button size="sm" variant="outline" onClick={() => decide(l.id, "approved")} data-testid={`leave-approve-${l.id}`}>{t("approve")}</Button>
                    <Button size="sm" variant="ghost" className="text-destructive" onClick={() => decide(l.id, "rejected")} data-testid={`leave-reject-${l.id}`}>{t("reject")}</Button>
                  </div>
                )}
              </li>
            );
          })}
          {items.length === 0 && <li className="p-12 text-center text-muted-foreground">{t("no_data")}</li>}
        </ul>
      </Card>
    </div>
  );
}
